import template from './infrastructure.jade';
import infrastructureCtrl from './infrastructure.controller';

export default () => {
    return {
        template,
        scope: {},
        bindToController: {
            ad: '=',
            setSegmentVisible: '&'
        },
        controller: infrastructureCtrl,
        controllerAs: 'infrastructureCtrl',
        replace: true,
    };
};
